import Vue from 'vue'
import Router from 'vue-router'
import TabBar from './routerPage/TabBar'
import Index from './routerPage/index'
import Home from './routerPage/Home'
import Login from './routerPage/login'
import Record from './routerPage/Record'
import Family from './routerPage/Family'

import seltTest from './routerPage/seltTest'
import Questionnaire from './routerPage/Questionnaire'
Vue.use(Router)
const baseRoutes =[
  ...TabBar,
  ...Index,
  ...Home,
  ...Login,
  ...Record,
  ...Family,
  ...seltTest,
  ...Questionnaire
  // 路由谁的路由在这加上就好了
]
// 测试解决刷新保存问题 有问题注释掉
const originalPush = Router.prototype.push
  Router.prototype.push = function push(location) {
   return originalPush.call(this, location).catch(err => err)
        }
// 测试解决路由警告  有问题注释掉
const createRouter = () => new Router({
    scrollBehavior: () => ({ y: 0 }),
    routes: baseRoutes
  })
  const router = createRouter()
  export function resetRouter() {
    const newRouter = createRouter()
    router.matcher = newRouter.matcher // reset router
  }
  export default router



// WEBPACK FOOTER //
// ./src/router/index.js